export enum WindowEvent {
  Resize = 'resize',
}
